const COOKIE_TO_PARAM = { _fbp: 'fbp', _fbc: 'fbc' };

export const getMetaCookies = () => {
  try {
    const cookies = document.cookie.split('; ').reduce((acc, entry) => {
      const separatorIndex = entry.indexOf('=');
      const name = entry.slice(0, separatorIndex).trim();
      const value = separatorIndex === -1 ? undefined : entry.slice(separatorIndex + 1);
      return COOKIE_TO_PARAM[name] && value ? { ...acc, [COOKIE_TO_PARAM[name]]: value } : acc;
    }, {});

    return cookies;
  } catch (error) {
    return {};
  }
};
